<template>
  <div>
    <download-excel
      style="width: 100px"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="兑换订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>

    <div style="margin-bottom: 16px; font-size: 14px; color: #333;">
      支付彩票总数：
      <span style="font-weight: bold; color: #f5222d;">{{ totalPayLottery }}</span>
    </div>

    <a-table
      :columns="columns"
      :row-key="(record) => record.userUid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      @change="handleTableChange"
    >
      <template slot="isReceive" slot-scope="text, isReceive">
        <span>{{ isReceive.isReceive === 0 ? "否" : "是" }}</span>
      </template>
      <template slot="orderStatus" slot-scope="text, record">
        <span v-if="record.orderStatus === 0 && record.isMail === true">待发货</span>
        <span v-else-if="record.orderStatus === 0">待领取</span>
        <span v-else-if="record.orderStatus === 3">已发货</span>
        <span v-else-if="record.orderStatus === 2">已领取</span>
        <span v-else>已取消</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, record">
        <span v-if="record.orderStatus === 2">
          <a
            class="test"
            href="javascript:;"
            v-on:click.prevent="
              topage(`/home/exchangeOrderDetailsTwo?orderNo=${record.orderNo}`)
            "
            >订单详情</a
          >
        </span>
        <span v-else>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <a href="" v-on:click.prevent="topage(`/home/exchangeOrderDetailsTwo?orderNo=${record.orderNo}`)">订单详情</a>
            <a href="javascript:;" v-if="record.orderStatus === 0 && record.isMail === true" @click="exchangeok2(record)">确认发货</a>
            <a href="javascript:;" v-if="record.orderStatus === 0" @click="exchangeok(record)">确认领取</a>
            <a href="javascript:;" v-if="record.orderStatus === 0 && !record.goodsName.includes('抽奖中奖奖品')" @click="exchangeno(record)">取消订单</a>
            <a href="javascript:;" v-if="record.trackingNumber" @click="exchangeok3(record)">修改单号</a>
          </div>
        </span>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeExchange,
  storeExchangeTrue,
  storeExchangeFalse,
  editExchangeType
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "订单号",
    dataIndex: "orderNo",
    scopedSlots: { customRender: "orderNo" },
    align: "center",
    width: 180

  },
  {
    title: "用户手机号码",
    dataIndex: "userPhone",
    align: "center",
  },
  {
    title: "卡号",
    dataIndex: "cardNo",
    align: "center",
  },
   {
    title: "卡类型名称",
    dataIndex: "cardTypeName",
    align: "center",
  },
  {
    title: "商品名称",
    dataIndex: "goodsName",
    scopedSlots: { customRender: "goodsName" },
    align: "center",
    width: 200
  },
  {
    title: "蓝票数量",
    dataIndex: "payLottery",
    align: "center",
    scopedSlots: { customRender: "payLottery" },
  },
   {
    title: "商品数量",
    dataIndex: "goodsNum",
    align: "center",
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "是否已完成",
    dataIndex: "isReceive",
    align: "center",
    scopedSlots: { customRender: "isReceive" },
  },
  {
    title: "订单状态",
    dataIndex: "orderStatus",
    scopedSlots: { customRender: "orderStatus" },
  },
  {
    title: "邮寄地址",
    dataIndex: "mailAddress",
    align: "center",
    scopedSlots: { customRender: "mailAddress" },
    width: 250,
    ellipsis: true
  },
  {
    title: "邮寄单号",
    dataIndex: "trackingNumber",
    align: "center",
    scopedSlots: { customRender: "trackingNumber" },
  },
  {
    title: "支付时间",
    dataIndex: "createTime",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        编号: "orderNo",
        用户手机号码: "userPhone",
        蓝票数量: "payLottery",
        所属门店: "shopName",
        是否已完成: "isReceive",
        订单状态: "orderStatus",
        支付时间: "createTime",
        邮寄地址: "mailAddress",
        邮寄单号: "trackingNumber",
        商品名称: "goodsName",
        商品数量: "goodsNum",
        卡类型名称: "cardTypeName",
        卡号: "cardNo",

      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      isShow:false,
      roleName:"",
      
    };
  },
  computed: {
    totalPayLottery() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data[0].totalLottery || 0;
    },
  },
  mounted() {
    this.getShow();
    if(this.isShow){
      this.getStoreExchangeList();
    }
    
  },
  props: ["formInline"],
  methods: {
      getShow(){
      this.roleName = sessionStorage.getItem("roleName")
      if(this.roleName && this.roleName.includes("收银")){
        this.isShow = false
      }else{
        this.isShow = true
      }
    },
    handleSubmit() {
      console.log(this.formInline);
    },
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const params = {
        ...this.formInline,
        page: 1,
        limit: 1
      };

      // 第一步：获取总数量，判断数据规模
      const countRes = await storeExchange(params);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        const params2 = {
        ...this.formInline,
        page: 1,
        limit: totalCount
      };
        // 数据量较小，一次性获取
        const res = await storeExchange(params2);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const params3 = {
              ...this.formInline,
              page: page,
              limit: pageSize
            }
            const res = await storeExchange(params3);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      this.formInline.page = this.pagination.current;
      storeExchange(this.formInline).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
    },
    // 确认领取
    exchangeok(row) {
      console.log('确认领取:',row);
      this.loading = true;
      storeExchangeTrue({ orderNo: row.orderNo, orderStatus: 2 ,partnerId:row.partnerId}).then(
        (res) => {
          this.loading = false;
          this.getStoreExchangeList();
          if (!res.success) {
            message.error(res.info);
          } else {
            message.success(res.data);
          }
        }
      );
    },

     // 确认发货
    exchangeok2(row) {
      console.log(row);
      const expressNo = prompt("请输入快递单号")
      if(!expressNo){
        message.error("请输入快递单号")
        return;
      }
      this.loading = true;
      storeExchangeTrue({ orderNo: row.orderNo, orderStatus: 3,expressNo:expressNo ,partnerId:row.partnerId}).then(
        (res) => {
          this.loading = false;
          this.getStoreExchangeList();
          if (!res.success) {
            message.error(res.info);
          } else {
            message.success(res.data);
          }
        }
      );
    },

    // 修改快递单号
    exchangeok3(row){
      const expressNo = prompt("请输入快递单号")
      if(!expressNo){
        message.error("请输入快递单号")
        return;
      }
      editExchangeType({
        orderNo:row.orderNo,
        trackingNumber:expressNo,
        userUid:row.userUid
      }).then(res =>{
        message.success(res.info)
        this.getStoreExchangeList()
      })
    },

    // 取消领取
    exchangeno(row) {
      console.log('取消领取:',row);
      if(row.goodsName && row.goodsName.includes('抽奖中奖奖品')){
        message.error("抽奖中奖奖品不能取消")
        return;
      }
      this.loading = true;
      storeExchangeFalse({ orderNo: row.orderNo, orderStatus: 1 }).then(
        (res) => {
          this.loading = false;
          this.getStoreExchangeList();
          if (!res.success) {
            message.error(res.info);
          } else {
            message.success(res.data);
          }
        }
      );
    },
    // 分页数据
    getStoreExchangeList() {
      storeExchange({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    seach() {
      if (this.formInline.orderNo === "" && this.isShow === false) {
        message.warning("订单编号不能为空");
        return;
      }
      this.loading = true;
      this.pagination.current = 1;
      storeExchange(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
        // console.log("storeExchange",res);
        if(res.code === 0 && res.data.length === 0){
          message.warning("没有查询到数据,检查订单编号是否正确");
        }
      });
    },
  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/exchangeOrderHomeContentTwo.vue